import { render, staticRenderFns } from "./BusinessUnitNew.vue?vue&type=template&id=f83fa454&"
import script from "./BusinessUnitNew.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports